define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"csi/html",
	"csi/view/ToolbarPlugin"
], function(declare,_WidgetBase,html,ToolbarPlugin) {

	return declare([_WidgetBase, ToolbarPlugin], {
		rootClass: "dijit dijitReset dijitInline csi-toolbar-anchor",
		disableClass: "dijitDisabled",

		/** @property {string} anchorHref - value for anchor href attribute */
		anchorHref: "",
		
		/** @property {DOMNode} anchorNode */
		anchorNode: null,

		/** @property {DOMNode} iconNode */
		iconNode: null,

		buildRendering: function() {
			const defAction = this.defAction;
			const isIcon = defAction.isIcon();
			const domNode = this.domNode = html.create("span", {
				"class": this.rootClass,
				title: defAction.getDescription()
			});
			
			const anchorNode = this.anchorNode = html.create("a", {
				"class": "csi-flex-inline",
				href: this.anchorHref,
				target: defAction.m_target ? defAction.m_target : "",
			}, domNode);
			
			const span = html.create("span", {
				"class": isIcon ? defAction.getIconCSS() : defAction.getCSS(),
				innerText: isIcon ? (defAction.materialIcon ? undefined : "") : defAction.m_name
			}, anchorNode);

			if (isIcon) {
				this.iconNode = span;
			}
		},

		postCreate: function() {
			this.inherited(arguments);
			this.addTooltip(this, this.defAction.m_id);
		},

		enablePlugin: function(ctx) {
			this._setDisabled(this, !ctx);
			this.domNode.classList.toggle(this.disableClass, this.disabled);
		}
	});
});
